import i18n from 'i18n-js';

import { AmericanFootballSimple } from '../../components';

import { TEMPLATES_TITLES } from '../templates';

export const AMERICANFOOTBALL_COMPONENTS = {
  [TEMPLATES_TITLES.AMERICANFOOTBALL_SIMPLE]: AmericanFootballSimple,
};

export const AMERICANFOOTBALL_DESIGNS_DATA = {
  [TEMPLATES_TITLES.AMERICANFOOTBALL_SIMPLE]: {
    design: {
      styles: [
        {
          id: 1,
          title: i18n.t('screens.builder.design.downDistanceDesign'),
          value: 'downDistance',
          items: [
            {
              id: 101,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
            {
              id: 102,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
          ],
        },
        {
          id: 2,
          title: i18n.t('screens.builder.design.teamNamesDesign'),
          value: 'teamName',
          items: [
            {
              id: 201,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
          ],
        },
        {
          id: 6,
          title: i18n.t('screens.builder.design.timeoutsDesign'),
          value: 'timeouts',
          items: [
            {
              id: 601,
              label: i18n.t('screens.builder.design.activateColor'),
              type: 'color',
              value: 'active',
            },
            {
              id: 602,
              label: i18n.t('screens.builder.design.inactiveColor'),
              type: 'color',
              value: 'inactive',
            },
          ],
        },
        {
          id: 3,
          title: i18n.t('screens.builder.design.pointsDesign'),
          value: 'points',
          items: [
            {
              id: 301,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
            {
              id: 302,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
          ],
        },
        {
          id: 4,
          title: i18n.t('screens.builder.design.quarterDesign'),
          value: 'quarter',
          items: [
            {
              id: 401,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
            {
              id: 402,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
          ],
        },
        {
          id: 5,
          title: i18n.t('screens.builder.design.timerDesign'),
          value: 'timer',
          items: [
            {
              id: 501,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
            {
              id: 502,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
          ],
        },
      ],
    },
  },
};

export default {
  AMERICANFOOTBALL_COMPONENTS,
  AMERICANFOOTBALL_DESIGNS_DATA,
};
